import {colors} from '../styles/theme/colors';

export const widgetColors = [
  {value: 'dark_blue', color: colors.primary.base},
  {value: 'grey', color: colors.grey[50]},
  {value: 'blue', color: colors.blue[50]},
  {value: 'green', color: colors.green[50]},
  {value: 'red', color: colors.red[50]},
  {value: 'orange', color: colors.orange[50]}
];
